import React from 'react'
import Table from '@common/Table'
import columns from './columns'
import store from '../store'

export default () => <Table store={store} columns={columns(store)} />
